import type { FanProfileMissingField } from '@/features/tasks/fanProfileCompleteness'

import S from './TasksCompleteProfileDialog.module.scss'

export function TasksCompleteProfileWarningIcon() {
  return (
    <svg
      className={S.warningTriangle}
      width="50"
      height="50"
      viewBox="0 0 34 34"
      aria-hidden
    >
      <path
        fill="#F0BF43"
        d="M14.855 5.25c.954-1.667 3.336-1.667 4.29 0l11.62 20.302c.954 1.667-.237 3.75-2.145 3.75H5.38c-1.908 0-3.099-2.083-2.145-3.75L14.855 5.25Z"
      />
      <path
        fill="#101014"
        d="M15.78 12.72h2.44v7.54h-2.44v-7.54Zm0 9.5h2.44v2.44h-2.44v-2.44Z"
      />
    </svg>
  )
}

type FieldIconProps = {
  field: FanProfileMissingField
}

export function TasksCompleteProfileFieldIcon({ field }: FieldIconProps) {
  if (field === 'favoriteClub') {
    return (
      <svg
        className={S.fieldIconSvg}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden
      >
        <path
          d="M12.1504 16.5V18.6"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.15039 22H17.1504V21C17.1504 19.9 16.2504 19 15.1504 19H9.15039C8.05039 19 7.15039 19.9 7.15039 21V22V22Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M6.15039 22H18.1504"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 16C8.13 16 5 12.87 5 9V6C5 3.79 6.79 2 9 2H15C17.21 2 19 3.79 19 6V9C19 12.87 15.87 16 12 16Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.46906 11.6501C4.71906 11.4101 4.05906 10.9701 3.53906 10.4501C2.63906 9.4501 2.03906 8.2501 2.03906 6.8501C2.03906 5.4501 3.13906 4.3501 4.53906 4.3501H5.18906C4.98906 4.8101 4.88906 5.3201 4.88906 5.8501V8.8501C4.88906 9.8501 5.09906 10.7901 5.46906 11.6501Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5293 11.6501C19.2793 11.4101 19.9393 10.9701 20.4593 10.4501C21.3593 9.4501 21.9593 8.2501 21.9593 6.8501C21.9593 5.4501 20.8593 4.3501 19.4593 4.3501H18.8093C19.0093 4.8101 19.1093 5.3201 19.1093 5.8501V8.8501C19.1093 9.8501 18.8993 10.7901 18.5293 11.6501Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

  if (field === 'birthDate') {
    return (
      <svg
        className={S.fieldIconSvg}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden
      >
        <path
          d="M4 8H20M16 2V4M8 2V4M7.2002 4H16.8002C17.9203 4 18.48 4 18.9078 4.21799C19.2841 4.40973 19.5905 4.71572 19.7822 5.09204C20.0002 5.51986 20 6.07985 20 7.19995V16.8C20 17.9201 20.0002 18.4802 19.7822 18.908C19.5905 19.2844 19.2841 19.5902 18.9078 19.782C18.48 20 17.9203 20 16.8002 20H7.2002C6.08009 20 5.51962 20 5.0918 19.782C4.71547 19.5902 4.40973 19.2844 4.21799 18.908C4 18.4802 4 17.9201 4 16.8V7.19995C4 6.07985 4 5.51986 4.21799 5.09204C4.40973 4.71572 4.71547 4.40973 5.0918 4.21799C5.51962 4 6.08009 4 7.2002 4Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

  if (field === 'gender') {
    return (
      <svg
        className={S.fieldIconSvg}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden
      >
        <path
          d="M12.1605 10.87C12.0605 10.86 11.9405 10.86 11.8305 10.87C9.45055 10.79 7.56055 8.84 7.56055 6.44C7.56055 3.99 9.54055 2 12.0005 2C14.4505 2 16.4405 3.99 16.4405 6.44C16.4305 8.84 14.5405 10.79 12.1605 10.87Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.1607 14.56C4.7407 16.18 4.7407 18.82 7.1607 20.43C9.9107 22.27 14.4207 22.27 17.1707 20.43C19.5907 18.81 19.5907 16.17 17.1707 14.56C14.4307 12.73 9.9207 12.73 7.1607 14.56Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }

  if (field === 'location') {
    return (
      <svg
        className={S.fieldIconSvg}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden
      >
        <path
          d="M12.0009 13.4299C13.724 13.4299 15.1209 12.0331 15.1209 10.3099C15.1209 8.58681 13.724 7.18994 12.0009 7.18994C10.2777 7.18994 8.88086 8.58681 8.88086 10.3099C8.88086 12.0331 10.2777 13.4299 12.0009 13.4299Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M3.61971 8.49C5.58971 -0.169998 18.4197 -0.159997 20.3797 8.5C21.5297 13.58 18.3697 17.88 15.5997 20.54C13.5897 22.48 10.4097 22.48 8.38971 20.54C5.62971 17.88 2.46971 13.57 3.61971 8.49Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    )
  }

  return (
    <svg className={S.fieldIconSvg} viewBox="0 0 24 24" fill="none" aria-hidden>
      <circle cx="12" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M6 19C6.8 16.2 9.1 14.5 12 14.5C14.9 14.5 17.2 16.2 18 19"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
